export default function Hero() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] lg:h-[700px] overflow-hidden">
      {/* Background Image — full-bleed landscape product grid */}
      <img
        src="https://readdy.ai/api/search-image?query=Luxury%20fashion%20accessories%20arranged%20in%20clean%20geometric%20grid%20pattern%20on%20warm%20cream%20marble%20surface%2C%20golden%20watches%20designer%20wallets%20sunglasses%20and%20premium%20leather%20bags%2C%20soft%20diffused%20natural%20daylight%2C%20minimal%20editorial%20product%20photography%2C%20warm%20caramel%20and%20beige%20tones%2C%20luxury%20catalog%20aesthetic%2C%20perfectly%20aligned%20high%20detail&width=1600&height=900&seq=hero-landscape-grid-v4&orientation=landscape"
        alt="Superbuy Spreadsheet curated fashion product grid featuring accessories"
        title="Superbuy Spreadsheet curated product collection"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />

      {/* Dark gradient overlay: heavier on the left, fading to transparent on the right */}
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/50 to-transparent" />

      {/* Content floats on the left side */}
      <div className="relative z-10 flex items-center h-full px-6 md:px-10 lg:px-16">
        <div className="max-w-xl">
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-background-50 leading-tight tracking-tight">
            Superbuy<br />Spreadsheet
          </h1>
          <p className="mt-6 text-base md:text-lg text-background-200/90 leading-relaxed max-w-lg">
            Discover, compare and understand products through organized resources, curated category databases and expert shopping guides — all in one place.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center px-8 py-3.5 bg-background-50 text-foreground-950 font-label font-semibold text-sm rounded-md hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Superbuy Sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 border-2 border-background-200/70 text-background-50 font-label font-semibold text-sm rounded-md hover:border-background-50 hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-arrow-right-line text-sm w-3.5 h-3.5 flex items-center justify-center"></i>
            </a>
          </div>

          <div className="mt-10 flex items-center gap-6">
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              <span className="text-xs font-label text-background-300 whitespace-nowrap">1,500+ Resources</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              <span className="text-xs font-label text-background-300 whitespace-nowrap">Updated Weekly</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}